import React, { useEffect, useState, useRef, useMemo } from 'react';

import axios from 'axios';
import DataTables from '../../components/DataTables';
import Swal from 'sweetalert2';
import './style.css';
import DateFilter from './Filters/DateFilter';
import StarIcon from '@material-ui/icons/Star';
import Approve from './Actions/approve';
import { useSelector, useDispatch } from 'react-redux';
import { authSelector } from '../../store/slices/auth';
import { selectedClientSelector } from '../../store/slices/selectedClient';
import textRatingToNumber from '../Client/ReviewsSection/services/textRatingToNumber';
import { v4 as uuid } from 'uuid';
import {
  API_REVIEW_UPDATE_MSG_REPLY,
  API_GET_GOOGLE_REVIEWS_V2,
  API_GET_YELP_REVIEWS,
  API_REVIEWS_HANDLER,
  REVIEWS_GENERATE_REPLY_BY_AI
} from '../../utils';
import { accountManagers } from '../../utils';
import { showLoading, hideLoading } from '../../store/slices/loadingState';

const Actions = ({ cell, row, refresh, setLoading, loading }) => {
  const reviews = useSelector((state) => state.reviews);
  const dispatch = useDispatch();

  const handleCancel = async () => {
    dispatch({
      type: 'reviews/setEditable',
      payload: { id: row.id, editable: false }
    });
  };

  const handleClick = async () => {
    if (reviews?.editable?.id === row.id && reviews?.editable?.editable) {
      dispatch({
        type: 'reviews/setEditable',
        payload: { id: row.id, editable: false }
      });
      if (
        reviews?.editable?.message &&
        reviews?.editable?.message.length > 0 &&
        reviews?.editable?.message !== row.msgReply
      ) {
        dispatch({
          type: 'reviews/save',
          payload: {
            loading: true,
            reviews: reviews?.reviews.map((review) =>
              review.id === row.id
                ? { ...review, msgReply: reviews?.editable?.message }
                : review
            )
          }
        });

        try {
          const response = await axios.post(`${API_REVIEW_UPDATE_MSG_REPLY}/`, {
            id: row.id,
            msgReply: reviews?.editable?.message
          });

          if (response.status === 200) {
            dispatch({
              type: 'reviews/save',
              payload: { loading: false }
            });
          }
        } catch (err) {
          console.error(err);
        }
      }
    } else if (!reviews?.editable?.editable) {
      dispatch({
        type: 'reviews/setEditable',
        payload: { id: row.id, editable: true, message: row.msgReply }
      });
    }
  };
  const handleApproved = (value) => {
    dispatch({
      type: 'reviews/approve',
      payload: reviews?.reviews.map((review) =>
        review.id === row.id ? { ...review, checked: value } : review
      )
    });
  };

  return (
    <div
      style={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column'
      }}>
      {!row?.checked ? (
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center'
          }}>
          {reviews?.editable?.editable && reviews?.editable?.id === row.id ? (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                height: '120px',
                justifyContent: 'space-evenly'
              }}>
              <button className="button-like-a nav-link" onClick={handleClick}>
                <i className="fas fa-lg fa-check" />
                <span style={{ color: 'gray', marginLeft: '10px' }}>
                  Confirm
                </span>
              </button>
              <button className="button-like-a nav-link" onClick={handleCancel}>
                <i
                  style={{ fontSize: '22px' }}
                  className="fas fa-lg fa-times"
                />
                <span style={{ color: 'gray', marginLeft: '10px' }}>
                  Cancel
                </span>
              </button>
            </div>
          ) : reviews?.loading ? (
            <>
              <div
                className="spinner-border spinner-border-sm ml-2"
                role="status"></div>
              <span style={{ color: 'gray', marginLeft: '10px' }}>loading</span>
            </>
          ) : (
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-around',
                alignItems: 'center',
                width: '85%'
                // backgroundColor: 'red'
              }}>
              <button
                className="button-like-a nav-link"
                onClick={handleClick}
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-evenly',
                  paddingRight: '5px',
                  paddingLeft: '5px',
                  height: '50px'
                }}>
                <i className="fas fa-fw fa-lg fa-pencil-alt feather" />
                <span style={{ color: 'gray' }}>Edit</span>
              </button>
              <button
                className="button-like-a nav-link"
                onClick={() => {
                  Swal.fire({
                    title: 'Delete Review',
                    text: 'Are you sure you want to delete?',
                    confirmButtonText: 'yes',
                    showCancelButton: true
                  }).then((res) => {
                    setLoading(true);
                    dispatch(showLoading());
                    if (res.value) {
                      axios
                        .post(API_REVIEWS_HANDLER, {
                          review: {
                            reviewId: row.reviewId,
                            locationId: row.locationId,
                            reviewer: row.reviewer,
                            starRating: row.starRating
                          },
                          request: {
                            sentBy: 'SUITE',
                            operation: 'deny'
                          }
                        })
                        .then((response) => {
                          dispatch(hideLoading());
                          setLoading(false);
                          refresh();

                          if (response.status === 200) {
                            Swal.fire({
                              title: 'Success!',
                              text: 'Review Deleted ✅',
                              showCloseButton: true
                            });
                          } else {
                            Swal.fire({
                              title: 'Error!',
                              text: 'Something went wrong ❌',
                              showCloseButton: true
                            });
                          }
                        });
                      //   .then((res) => {
                      //     if (res.value) {
                      //       setChange(!change);
                      //     }
                      //   });
                      // })
                      // .catch((error) => {
                      //   Swal.fire({
                      //     title: 'Error!',
                      //     icon: 'error',
                      //     text: 'Have problems deleting.'
                      //   });
                      //   console.error('error ' + error);
                      // });
                    }
                  });
                }}
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-evenly',

                  paddingRight: '5px',
                  paddingLeft: '5px',
                  height: '50px',
                  textAlign: 'center'
                }}>
                <i
                  style={{
                    marginLeft: '7px'
                  }}
                  className="fas fa-fw fa-lg fa-trash feather"
                />
                <span style={{ color: 'gray' }}>Delete</span>
              </button>
            </div>
          )}
        </div>
      ) : (
        <></>
      )}
      {(reviews?.editable?.editable && reviews?.editable?.id === row.id) ||
      reviews?.loading ? (
        <></>
      ) : (
        <div style={{}}>
          <Approve
            loading={loading}
            approved={row?.checked}
            reviewId={row?.reviewId}
            callback={handleApproved}
          />
        </div>
      )}
    </div>
  );
};

const Answer = ({ cell, row }) => {
  const reviews = useSelector((state) => state.reviews);
  const selectedClient = useSelector(selectedClientSelector);
  const editable =
    reviews?.editable?.editable && reviews?.editable?.id === row.id;
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const handleEditMessage = (msg) => {
    dispatch({ type: 'reviews/editMessage', payload: msg });
  };

  const handleAutoGenerate = async () => {
    try {
      setLoading(true);
      const res = await fetch(REVIEWS_GENERATE_REPLY_BY_AI, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          review: row,
          name: row?.reviewer?.displayName,
          singlePerson: selectedClient?.selectedClient?.singlePerson
        })
      });

      const msg = await res.text();
      if (msg) {
        handleEditMessage(msg);
      }
    } catch (err) {
      console.error('Error generating message', err);
    } finally {
      setLoading(false);
    }
  };

  if (editable && reviews?.editable?.id === row.id) {
    return (
      <div
        className="flex-grow-1 flex-shrink-1"
        style={{ position: 'relative' }}>
        <p className="mb-1 event-desc tx-gray-900 mg-b-40">
          <textarea
            id={`msgReply-${row.id}`}
            name={`msgReply-${row.id}`}
            type="text"
            disabled={!editable || loading}
            className="form-control"
            placeholder="Edit the review answer message here"
            defaultValue={cell}
            value={!editable ? cell : reviews.editable.message}
            style={{
              borderRadius: '3px',
              paddingLeft: '12px',
              paddingRight: '12px',
              paddingBottom: '10px',
              marginLeft: '5px',
              marginBottom: '20px',
              minHeight: '180px',
              maxHeight: '100%',
              width: '97%',
              resize: editable ? 'none' : 'none',
              border: editable ? '1px solid #ced4da' : 'none',
              backgroundColor: 'inherit'
            }}
            onChange={(e) => {
              handleEditMessage(e.target.value);
            }}></textarea>
        </p>
        {row?.rev_comment && (
          <button
            type="button"
            onClick={handleAutoGenerate}
            disabled={loading}
            style={{
              position: 'absolute',
              bottom: '12px',
              right: '18px',
              backgroundColor: '#cce4ff',
              border: 'none',
              borderRadius: '50%',
              width: '32px',
              height: '32px',
              color: '#000',
              // fontSize: '14px',
              boxShadow: '0 1px 4px rgba(0,0,0,0.15)',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: '0.2s ease'
            }}
            title="Auto Generate">
            <style>
              {`
      @keyframes spinReverse {
        100% {
          transform: rotate(-360deg);
        }
      }
    `}
            </style>

            <svg
              viewBox="0 0 32 32"
              xmlns="http://www.w3.org/2000/svg"
              fill="3867a8"
              stroke="3867a8"
              transform="rotate(310)"
              style={
                loading
                  ? {
                      animation: 'spinReverse 1s linear infinite'
                    }
                  : {}
              }>
              <g id="SVGRepo_iconCarrier">
                {' '}
                <g fill="none" fill-rule="evenodd">
                  {' '}
                  <path
                    d="m16 0c8.836556 0 16 7.163444 16 16s-7.163444 16-16 16-16-7.163444-16-16 7.163444-16 16-16zm7.5013519 8h-5c-.5522847 0-1 .44771525-1 1v5c0 .5522847.4477153 1 1 1 .5522848 0 1-.4477153 1-1l.0011164-2.872584c1.5476338 1.1131888 2.4975317 2.9096298 2.4975317 4.872584 0 3.3137085-2.6862915 6-6 6s-6-2.6862915-6-6c0-2.6791615 1.771854-5.0121287 4.3028795-5.7568853.5298238-.1559011.832948-.71179106.6770468-1.24161488-.1559011-.52982382-.711791-.83294803-1.2416148-.67704688-3.3764809.99353263-5.7383115 4.10331096-5.7383115 7.67554706 0 4.418278 3.581722 8 8 8s8-3.581722 8-8c0-2.3423774-1.015734-4.5083081-2.7082286-6.00072306l2.2095805.00072306c.5522848 0 1-.44771525 1-1s-.4477152-1-1-1z"
                    fill="#3867a8"></path>{' '}
                </g>{' '}
              </g>
            </svg>
          </button>
        )}
      </div>
    );
  } else {
    return <>{cell}</>;
  }
};

const Reviews = (props) => {
  const { userInfo } = useSelector(authSelector);
  const [showReplied, setShowReplied] = useState(false);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState(null);
  const [showGoogleReviews, setShowGoogleReviews] = useState(true);
  const [refresh, setRefresh] = useState(false);

  const handleSetShowGoogleReviews = () => {
    setShowGoogleReviews(!showGoogleReviews);
  };

  const defaultDates = {
    startDate: getDaysAgoUnix(),
    endDate: getCurrentUnix()
  };
  const reviews = useSelector((state) => state?.reviews?.reviews);
  const dispatch = useDispatch();

  const setStateReviews = (reviews) => {
    dispatch({ type: 'reviews/setReviews', payload: reviews });
  };
  const handleFilterChange = (newFilter) => {
    setFilter(newFilter);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const getReviews = async (queryParams) => {
    setStateReviews([]);
    setLoading(true);
    dispatch(showLoading());

    let url = showGoogleReviews
      ? API_GET_GOOGLE_REVIEWS_V2
      : API_GET_YELP_REVIEWS;

    axios.get(url, { params: { ...queryParams } }).then((res) => {
      let reviews = res.data;
      reviews = reviews.map((item) => {
        item.id = item.reviewId;
        // Search the account manager by his id
        const manager = accountManagers.find(
          (manager) => manager.id === item.accountOwner
        );

        // Verify if the manager exists
        if (manager) {
          item.assignedTo = manager.full_name;
        } else {
          console.info(
            `There's no account manager with the id: ${item.accountOwner}`
          );
        }

        return item;
      });
      const sortedData = reviews.sort(
        (a, b) => b.createdTimeUnix - a.createdTimeUnix
      );
      setStateReviews(sortedData);
      dispatch(hideLoading());
      setLoading(false);
    });
  };

  function getDaysAgoUnix() {
    const today = new Date();
    today.setDate(today.getDate() - 7);
    return Math.floor(today.getTime()); // Convertir a segundos
  }

  function getCurrentUnix() {
    return Math.floor(new Date().getTime()); // Convertir a segundos
  }

  const Rating = (cell, row) => {
    const stars = [];
    const rating = showGoogleReviews
      ? textRatingToNumber(row.starRating)
      : row.starRating;

    for (let i = 0; i < rating; i++) {
      stars.push(<StarIcon key={uuid()} className="star" />);
    }

    return <div>{stars}</div>;
  };
  const RepliedBy = (cell, row) => {
    if (!row?.checked) {
      return <div style={{ color: '#8392A5' }}>Pending by Account Owner</div>;
    } else if (!row.replied && row.schedule && !row?.rejected) {
      return <div style={{ color: '#8392A5' }}>Pending (scheduled)</div>;
    } else if (row.rejected) {
      return <div style={{ color: '#8392A5' }}>Denied</div>;
    } else if (row.replied && !row.schedule) {
      return <div style={{ color: '#8392A5' }}>Sent By AI</div>;
    } else if (
      (row.replied && row.schedule > Math.floor(Date.now() / 1000)) ||
      (row.replied && row.approved)
    ) {
      return <div style={{ color: '#8392A5' }}>Approved by Client</div>;
    } else if (!row.replied && !row.schedule && row?.checked) {
      return <div style={{ color: '#8392A5' }}>Pending by scheduler</div>;
    } else if (!row.replied && !row.schedule) {
      return <div style={{ color: '#8392A5' }}>Pending by Client</div>;
    } else if (row.replied && !row.rev_comment) {
      return <div style={{ color: '#8392A5' }}>Replied by Client</div>;
    } else {
      return <div style={{ color: '#8392A5' }}>Sent By AI</div>;
    }
  };

  const DateFormat = (cell, row) => {
    if (cell && !row.rejected) {
      if (showGoogleReviews) {
        return new Date(cell * 1000).toLocaleDateString();
      } else {
        return new Date(cell).toLocaleDateString();
      }
    } else {
      return <>--</>;
    }
  };
  useEffect(() => {
    if (filter !== null) {
      console.log('changed', filter);
    }
    getReviews({ replied: showReplied, ...filter });
  }, [filter, showReplied, showGoogleReviews, refresh]);

  const [expandedRows, setExpandedRows] = useState([]);

  const toggleRowExpansion = (rowId) => {
    setExpandedRows((prev) =>
      prev.includes(rowId)
        ? prev.filter((id) => id !== rowId)
        : [...prev, rowId]
    );
  };

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTo({
        top: scrollPosition.current,
        behavior: 'auto'
      });
    }
  }, [expandedRows]);

  const CHARACTER_LIMIT = 100;

  const commentFormatter = (cell, row) => {
    const text = cell || '--';
    const isExpanded = row._expanded;
    const displayText =
      !isExpanded && text.length > CHARACTER_LIMIT
        ? text.slice(0, CHARACTER_LIMIT) + '...'
        : text;

    return (
      <div>
        <div>{displayText}</div>
        {text.length > CHARACTER_LIMIT && (
          <button
            onClick={() => toggleRowExpansion(row.id)}
            style={{
              border: 'none',
              background: 'none',
              color: '#007bff',
              cursor: 'pointer',
              padding: 0,
              fontSize: '0.85rem',
              marginTop: '5px'
            }}>
            {isExpanded ? 'View less' : 'View more'}
          </button>
        )}
      </div>
    );
  };

  const answerFormatter = (cell, row) => {
    if (row._isEditing) return <Answer cell={cell} row={row} />;

    const text = cell || '--';

    const isEditing =
      reviewsSlice?.editable?.editable && reviewsSlice.editable.id === row.id;

    if (isEditing) {
      return <Answer cell={cell} row={row} />;
    }

    const isExpanded = row._expanded;
    const displayText =
      !isExpanded && text.length > CHARACTER_LIMIT
        ? text.slice(0, CHARACTER_LIMIT) + '...'
        : text;

    return (
      <div>
        <div>{displayText}</div>
        {text.length > CHARACTER_LIMIT && (
          <button
            onClick={() => toggleRowExpansion(row.id)}
            style={{
              border: 'none',
              background: 'none',
              color: '#007bff',
              cursor: 'pointer',
              padding: 0,
              fontSize: '0.85rem',
              marginTop: '5px'
            }}>
            {isExpanded ? 'View less' : 'View more'}
          </button>
        )}
      </div>
    );
  };

  const clientColumns = useMemo(
    () => [
      {
        dataField: 'locationName',
        text: 'Client Name',
        hidden: !showGoogleReviews,
        headerStyle: () => {
          return {
            width: '250px',
            textAlign: 'left'
          };
        },
        style: () => {
          return {
            paddingTop: '12px',
            textAlign: 'left'
          };
        },
        formatter: (cell, row) => {
          return (
            <div>
              {row?.googleLink1 || row?.googleLink2 ? (
                <a target="n_blank" href={row?.googleLink2 || row?.googleLink1}>
                  {cell}
                </a>
              ) : (
                cell
              )}{' '}
            </div>
          );
        }
      },
      {
        dataField: 'reviewer.displayName',
        text: 'Name',
        hidden: !showGoogleReviews,
        headerStyle: () => {
          return {
            width: '120px',
            textAlign: 'center'
          };
        },
        style: () => {
          return {
            paddingTop: '12px',
            textAlign: 'center'
          };
        }
      },
      {
        dataField: 'createdTimeUnix',
        text: 'Created On',
        headerStyle: () => {
          return {
            width: '100px',
            textAlign: 'center'
          };
        },
        style: () => {
          return {
            paddingTop: '12px',
            textAlign: 'center'
          };
        },
        formatter: DateFormat
      },
      {
        dataField: 'starRating',
        text: 'Stars',
        headerStyle: () => {
          return {
            width: '145px',
            textAlign: 'center'
          };
        },
        style: () => {
          return {
            paddingTop: '12px',
            textAlign: 'center'
          };
        },
        formatter: Rating
      },
      {
        dataField: 'rev_comment',
        text: 'Comment',
        headerStyle: () => ({ width: '270px' }),
        style: (cell, row) => ({
          paddingTop: '12px',
          textAlign: !cell ? 'center' : 'left'
        }),
        formatter: commentFormatter
      },
      {
        dataField: 'msgReply',
        text: 'Answer',
        hidden: !showGoogleReviews,
        headerStyle: () => ({ width: '270px' }),
        style: () => ({ paddingTop: '12px' }),
        formatter: answerFormatter
      },
      {
        dataField: 'assignedTo',
        text: 'Assigned to',
        hidden: !showGoogleReviews,
        headerStyle: () => {
          return {
            width: '100px',
            textAlign: 'center'
          };
        },
        style: () => {
          return {
            paddingTop: '12px',
            textAlign: 'center'
          };
        }
      },
      {
        dataField: 'replied',
        text: 'Replied by',
        hidden: !showGoogleReviews,
        headerStyle: () => {
          return {
            width: '85px',
            textAlign: 'center'
          };
        },
        style: () => {
          return {
            paddingTop: '12px',
            textAlign: 'center'
          };
        },
        formatter: RepliedBy
      },
      {
        dataField: 'schedule',
        text: 'Scheduled for',
        hidden: !showGoogleReviews,
        headerStyle: () => {
          return {
            width: '115px',
            textAlign: 'center'
          };
        },
        style: () => {
          return {
            paddingTop: '12px',
            textAlign: 'center'
          };
        },
        formatter: DateFormat
      },
      {
        dataField: 'actions',
        text: 'Actions',
        hidden: showReplied || !showGoogleReviews,
        headerStyle: () => {
          return {
            width: '110px',
            textAlign: 'center'
          };
        },
        style: () => {
          return {
            width: '100%',
            minHeight: '100px',
            marginBottom: '-2px',
            display: 'flex',
            justifyContent: 'center',
            padding: '3px',
            paddingTop: '15px',
            minHeight: '218px',
            flexDirection: 'column'
          };
        },
        formatter: (cell, row) => (
          <Actions
            row={row}
            cell={cell}
            refresh={() => {
              setRefresh(!refresh);
            }}
            setLoading={setLoading}
          />
        )
      }
    ],
    [showGoogleReviews]
  );

  const [selectedColumnIds, setSelectedColumnIds] = useState(
    clientColumns.map((col) => col.dataField)
  );

  const filteredColumns = clientColumns.filter((col) =>
    selectedColumnIds.includes(col.dataField)
  );

  const reviewsSlice = useSelector((state) => state.reviews);
  const containerRef = useRef(null);
  const scrollPosition = useRef(0);
  const dataWithFlags = reviews.map((row) => ({
    ...row,
    _expanded: expandedRows.includes(row.id),
    _isEditing:
      reviewsSlice.editable.editable && reviewsSlice.editable.id === row.id
  }));

  return (
    <>
      <div
        className="content ht-100v pd-0 datatable-content-body"
        ref={containerRef}>
        <DataTables
          buttonsCallback={() => {}}
          userRole={userInfo.role}
          data={dataWithFlags}
          columns={filteredColumns}
          noDataIndication={loading ? 'Loading...' : 'No Reviews'}
          handleModal={() => handleSetShowGoogleReviews()}
          alternTitle="reviews"
          title={`${showGoogleReviews ? 'Google' : 'Yelp'} Reviews ${
            reviews?.length > 0
              ? `(${reviews?.length}) ${showReplied ? 'replied' : ''}`
              : ``
          }`}
          loading={loading}
          showTotal={false}
          view={'reviews'}
          viewState={{ showGoogleReviews }}>
          <DateFilter
            filter={filter}
            showGoogleReviews={showGoogleReviews}
            showReplied={showReplied}
            defaultDates={defaultDates}
            onFilterChange={handleFilterChange}
            accountManagers={accountManagers}
            loading={loading}
            setShowReplied={setShowReplied}
            allColumns={clientColumns}
            onColumnsChange={setSelectedColumnIds}
            initialSelectedColumns={selectedColumnIds}
          />
        </DataTables>
      </div>
    </>
  );
};

export default Reviews;
